export function boolean(value: string | boolean): boolean | 'Campo inválido' {
  return value === true || value === false || value === 'true' || value === 'false' || 'Campo inválido'
}
